export enum AuthState {
  SIGN_UP = 'sign-up',
  SIGN_IN = 'sign-in',
  FORGOT_PASSWORD = 'forgot-password',
  VERIFY_ACCOUNT = 'verify-account',
  RESET_PASSWORD = 'reset-password',
  RESET_SUCCESS = 'reset-success',
  OTP_VERIFICATION = 'otp-verification',
  SIGNUP_SUCCESS = 'signup-success',
  REFERRAL_CODE = 'referral-code',
}
